import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { useDark } from "@vueuse/core";


export default /*#__PURE__*/_defineComponent({
  name: 'HeaderLogo',
  setup(__props) {

const isDark = useDark();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    src: `assets/images/phix_${_unref(isDark) ? 'light' : 'dark'}.png`,
    alt: "Phix",
    class: "header-logo",
    height: "40"
  }, null, 8, _hoisted_1))
}
}

})